'use client'
import { useState } from 'react'
import { Popover } from 'antd'
import useI18n from 'Hooks/useI18n'
import { BellOutlined } from '@ant-design/icons'
import LetterPage from './LetterPage'
import { useLetterReadStatus } from 'Hooks/letter/useLetterReadStatus'

export default function Letter() {
  const { t } = useI18n()
  const [open, setOpen] = useState(false)

  const { data: readStatus } = useLetterReadStatus()

  return (
    <Popover
      open={open}
      onOpenChange={setOpen}
      content={
        <div className="h-[538px] w-[428px]">
          <LetterPage />
        </div>
      }
      trigger="click"
      transitionName=""
      overlayInnerStyle={{
        background:
          'linear-gradient(180deg, rgba(0,0,0,0.8) 0%, rgba(87,47,102,0.8) 50%, rgba(29,21,21,0.8) 100%)',
        backdropFilter: 'blur(12px)',
        WebkitBackdropFilter: 'blur(12px)',
        willChange: 'backdrop-filter',
        transform: 'translateZ(0)',
        border: '1px solid rgba(255,255,255,0.6)',
        padding: '0',
        borderRadius: '10px',
        overflow: 'hidden',
      }}
      placement="bottomLeft"
      arrow={false}
    >
      <button
        aria-label={t('Notification')}
        className="pointer-events-auto relative flex h-10 w-10 items-center justify-center rounded-full border border-secondary-border bg-secondary-bg transition hover:border-hover-border"
      >
        <BellOutlined style={{ fontSize: '20px' }} />
        {readStatus?.unread_messages && (
          <div className="absolute right-0 top-0 h-2.5 w-2.5 rounded-full bg-red-500" />
        )}
      </button>
    </Popover>
  )
}
